import { z } from 'zod'

// Mirrors `PrecedentOutcomeKind` in the requests service. Redeclared here because `universal` must not
// depend on a service; the kinds are a stable contract, not an implementation detail.
export const TASK_PRECEDENT_OUTCOME_KINDS = [
  'approved',
  'rejected',
  'approved_with_amendments',
  'rejected_then_approved',
] as const
export const TaskPrecedentOutcomeKindSchema = z.enum(TASK_PRECEDENT_OUTCOME_KINDS)

export const TaskPrecedentCitationAgentInputSchema = z.object({
  type: z.literal('task_precedent'),
  requestStepId: z
    .string()
    .describe('The stable requestStepId surfaced by getPrecedentDetails for the similar past review being cited.'),
})

// Whole-precedent grain: one citation per precedent, with no `citedFacts`. A precedent's value is
// analogical (a comparable review's outcome), not a quoted field value, so there is nothing to anchor.
// `requestId` is the FE navigation target (open the source review).
export const TaskPrecedentCitationResolvedSchema = z.object({
  sourceType: z.literal('task_precedent'),
  sourceLabel: z.string().nullable(),
  requestStepId: z.string(),
  requestId: z.string(),
  requestName: z.string().nullable(),
  outcomeKind: TaskPrecedentOutcomeKindSchema,
  reviewedAt: z.string().nullable(),
})
export type TaskPrecedentCitationResolved = z.infer<typeof TaskPrecedentCitationResolvedSchema>
